module.exports = __webpack_public_path__ + "static/media/setup-business-info.df939901.svg";